import { API_URL } from '../components/common/Config';
import { encryptPayload, normalizeEncryptedApiResponse } from './customerCrypto';
import { ensureCompanySettings, resolveCustomerApiEncrypt } from './companySettingsCache';

export async function postUserRolesWithPermissions(bearerToken, { userId, roleId = null } = {}) {
  const settings = await ensureCompanySettings();
  const useEncrypt = resolveCustomerApiEncrypt(settings);
  const formData = new FormData();
  const payload = { user_id: String(userId) };

  if (roleId != null && roleId !== '') {
    payload.role_id = String(roleId);
  }

  if (useEncrypt) {
    const ep = encryptPayload(payload);
    if (!ep) {
      return { response: null, data: null };
    }
    formData.append('encrypted_payload', ep);
  } else {
    formData.append('user_id', payload.user_id);
    if (payload.role_id) {
      formData.append('role_id', payload.role_id);
    }
  }

  const response = await fetch(`${API_URL}/get_user_roles_with_permissions`, {
    method: 'POST',
    headers: {
      authorization: `Bearer ${bearerToken}`,
    },
    body: formData,
  });

  const raw = await response.json();
  const data = normalizeEncryptedApiResponse(raw, useEncrypt) ?? raw;
  return { response, data };
}
